

/*
FrFr FRIENDLY FRAMEWORK
frfr-draftel-counter-utils
Version ID: 1a 2023-01-05r1
by 
// Please describe here if you customized this file
*/


let draftelCounter_state = 0;
let tempkeyCounter_state = 0;

export const draftelCounter = {};
export const tempkeyCounter = {};


// draftelCounter

draftelCounter.generateFreshSubkey = (n) => {
  draftelCounter_state++;
  if (n > draftelCounter_state || n === draftelCounter_state) {
    draftelCounter_state = n + 1;
  }
  return draftelCounter_state;
};

draftelCounter.updateSmart = (n) => {
  if (n > draftelCounter_state || n === draftelCounter_state) {
    draftelCounter_state = n + 1;
  }
  return true;
};

draftelCounter.resetCounter = () => {
  draftelCounter_state = 0;
  return true;
};


// tempkeyCounter

tempkeyCounter.generateFreshTempkey = (n) => {
  tempkeyCounter_state++;
  if (n > tempkeyCounter_state || n === tempkeyCounter_state) {
    tempkeyCounter_state = n + 1;
  }
  return tempkeyCounter_state;
};

tempkeyCounter.updateSmart = (n) => {
  if (n > tempkeyCounter_state || n === tempkeyCounter_state) {
    tempkeyCounter_state = n + 1;
  }
  return true;
};

tempkeyCounter.resetCounter = () => {
  tempkeyCounter_state = 0;
  return true;
};